module.exports = __webpack_public_path__ + "img/save_1.b87a2526.png";